import React from "react";


const ITradeLineChartLegend = ({ iTrade, avgTrade }) => {
    return (
        <div className="is-flex" style={{ justifyContent: "center" }}>
            <div className="text-right" style={{ fontSize: "0.8em", paddingRight: "20px" }}>
                <div className="is-inline-block trade-line-chart-legend-d" style={{ marginRight: "5px", width: "20px", height: "0.8em" }}></div>
                {iTrade}
            </div>
            <div className="text-left" style={{ fontSize: "0.8em", }}>
                <div className="is-inline-block trade-line-chart-legend-text" style={{ marginRight: "5px", width: "20px", height: "0.8em" }}></div>
                {avgTrade}
            </div>
        </div>
    )
}
export default ITradeLineChartLegend;